import type { ProductRoomI18nFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (serverModel: ServerModel): ProductRoomI18nFormModel["InputModel"] => {
	const { roomI18n } = serverModel;

	const inputModel: ProductRoomI18nFormModel["InputModel"] = {
		hotelID: roomI18n.hotelID,
		roomID: roomI18n.roomID,
		lang: roomI18n.lang,
		catchCopy: roomI18n.catchCopy,

		name: roomI18n.name,

		address: {
			city: roomI18n.address?.city,
			nationality: roomI18n.address?.nationality,
			other: roomI18n.address?.other,
			postalCode: roomI18n.address?.postalCode,
			pref: roomI18n.address?.pref,
			state: roomI18n.address?.state,
			town: roomI18n.address?.town,
		},
		description: roomI18n.description,
	} satisfies ProductRoomI18nFormModel["InputModel"];
	return inputModel;
};
